import { ReactFuri } from 'react-furi';
import type { Token } from '../../types';
import { KANJI_RE, JAPANESE_RE } from '../../utils/japanese';

interface Props {
  tokens: Token[];
  showFurigana: boolean;
}

export default function TokenRenderer({ tokens, showFurigana }: Props) {
  if (showFurigana) {
    return (
      <>
        {tokens.map((token, ti) => {
          if (token.surface === '\n') return <br key={ti} />;
          if (!JAPANESE_RE.test(token.surface)) {
            return <span key={ti}>{token.surface}</span>;
          }
          if (KANJI_RE.test(token.surface) && token.reading) {
            return (
              <span key={ti} data-ti={ti} className="token-el token-el-furi">
                <ReactFuri
                  word={token.surface}
                  reading={token.reading}
                  showFuri
                  render={({ pairs }: { pairs: [string, string][] }) => (
                    <>
                      {pairs.map(([furiText, text], i) => (
                        <span key={i} className="furi-pair-baseline">
                          <span className="furi-above">{furiText}</span>
                          {text}
                        </span>
                      ))}
                    </>
                  )}
                />
              </span>
            );
          }
          return <span key={ti} data-ti={ti} className="token-el">{token.surface}</span>;
        })}
      </>
    );
  }

  return (
    <>
      {tokens.map((token, ti) => {
        if (token.surface === '\n') return <br key={ti} />;
        if (!JAPANESE_RE.test(token.surface)) return <span key={ti}>{token.surface}</span>;
        return (
          <span key={ti} data-ti={ti} className="token-el char-jp">
            {token.surface.split('').map((char, ci) => (
              <span key={ci}>{char}</span>
            ))}
          </span>
        );
      })}
    </>
  );
}
